import { useEffect, useState } from "react";
import "react-toastify/dist/ReactToastify.css";
import "./testGenAI.css";
import axios from "axios";

import { toast, ToastContainer } from "react-toastify";
import InfiniteScroll from "react-infinite-scroll-component";
import { Box } from "@mui/material";

import TimeCategorizedChatList from "./TimeCategorizedChatList";
import TopBar from "./TopBar";

const ChatHistoryPage = ({
  displayName,
  userEmail,
  onSelectConversation,
  onNewChat,
  chatWrapperRef,
  submenuCode
}) => {
  const [allConversations, setAllConversations] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  useEffect(() => {
    getAllConversations();
  }, []);
  const getAllConversations = () => {
    let limit = 20;
    const offset = page;
    const api_url =
      window.configs.BASE_API_URL + window.configs.CHAT_CONVERSATIONS_URL;
    axios
      .get(api_url + "/" + userEmail + "/"+ submenuCode + "?limit=" + limit + "&offset=" + offset)
      .then((response) => {
        if (response.status === 200) {
          const newConversations = response.data;
          if (newConversations.length === 0) {
            setHasMore(false); // no more data to load
            return;
          }
          const sortedNewConversations = [...newConversations].sort(
            (a, b) => new Date(b.updated_at) - new Date(a.updated_at)
          );
          setAllConversations((prev) => [...prev, ...sortedNewConversations]);
          setPage((prev) => prev + 1); // increment page for next fetch
        }
      })
      .catch((error) => {
        toast.info("Something went wrong", {
          duration: 1000,
          position: "bottom-right",
          theme: "colored",
        });
      });
  };
  return (
    <div className="analytics">
      <TopBar
        displayName={displayName}
        showNewChat={true}
        showHistoryButton={false}
        onNewChat={onNewChat}
        onViewHistory={() => {}}
      />
      <div className="card cardAdditionalStyling">
        <ToastContainer />
        <div
          ref={chatWrapperRef}
          className="card subcard box-container"
          id="mainScrollableDiv"
        >
          <Box className="messageBox">
            <Box className="boxStyling">
              <InfiniteScroll
                dataLength={allConversations.length}
                next={() => {
                  getAllConversations();
                }}
                scrollableTarget="mainScrollableDiv"
                hasMore={hasMore}
                loader={
                  <p
                    style={{
                      textAlign: "center",
                      color: "gray",
                      padding: "1rem",
                    }}
                  >
                    <b>No more conversations</b>
                  </p>
                }
                endMessage={
                  <p
                    style={{
                      textAlign: "center",
                      color: "gray",
                      padding: "1rem",
                    }}
                  >
                    <b>No more conversations</b>
                  </p>
                }
              >
                <TimeCategorizedChatList
                  allConversations={allConversations}
                  onSelectConversation={onSelectConversation}
                />
              </InfiniteScroll>
            </Box>
          </Box>
        </div>
      </div>
    </div>
  );
};

export default ChatHistoryPage;
